
























































































































































import { Component, Mixins } from "vue-property-decorator";
import { ContractIdValidatorMixin } from "@/mixins/ContractIdValidatorMixin";
import FormValidator from "@/mixins/FormValidator";
import { ChangePlanModule } from "@/store/change-plan.module";
import { translate } from "@/utils";
import DateMixin from "@/mixins/DateMixin";
import { ReportAction } from "~/services/report";
import { ReportsModule } from "@/store/reports.module";
import { AuthModule } from "@/store/auth.module";
import * as xml2js from "xml2js";
import { SignService } from "@/services/sign.service";
import { BaseModule } from "@/store/base.module";
import ECPSigner from "@/components/ui/ECPSigner.vue";
import MobileDetect from "mobile-detect";

@Component({
  components: { ECPSigner },
})
export default class ChangePlanAddEditView extends Mixins(
  ContractIdValidatorMixin,
  FormValidator,
  DateMixin,
) {
  formRef = "form";

  $refs: {
    ecpSingerRef: ECPSigner;
  };

  actions: boolean = false;
  iContractRid: number;
  iReqRid: number | null;

  async clickCancel() {
    await this.changeStatus("canceled", {});
    this.gotoHome();
  }

  get showCancelBtn() {
    return (
      ChangePlanModule.currentPlan &&
      ChangePlanModule.currentPlan.status_code === "draft"
    );
  }

  get showDraftBtn() {
    return (
      this.iReqRid == null ||
      (ChangePlanModule.currentPlan &&
        ChangePlanModule.currentPlan.status_code === "draft")
    );
  }

  get showSendBtn() {
    return (
      this.iReqRid == null ||
      (ChangePlanModule.currentPlan &&
        ChangePlanModule.currentPlan.status_code != "canceled" &&
        ChangePlanModule.currentPlan.status_code != "executed")
    );
  }

  get tcurrentPlan() {
    return translate(this.currentPlan);
  }

  get currentPlan() {
    return ChangePlanModule.planList.find(
      x => x.record_id == ChangePlanModule.currentPlan.record_id,
    );
  }

  async checkExists() {
    const exists = await ChangePlanModule.checkExistsChangePlan(
      this.iContractRid,
    );
    if (exists && exists.result) {
      BaseModule.showMessage({
        message: this.$t("actions.change-plan.once").toString(),
        color: "error",
      });
      return true;
    } else return false;
  }

  async saveDraft() {
    if (!this.validateForm()) {
      return;
    }
    try {
      this.actions = true;
      //if (await this.checkExists()) return;
      const result = await this.saveData();
      if (result) {
        this.gotoHome();
      }
    } finally {
      this.actions = false;
    }
  }

  gotoHome() {
    this.$router.push({
      name: "change-plan",
    });
  }

  async saveData() {
    const list = this.planDetailList.map(x => ({
      month: x.month,
      value_current: x.value_current,
      value_edit: x.value_edit,
    }));
    const result = await ChangePlanModule.savePlan({
      iContractRid: this.iContractRid,
      iReqRid: this.iReqRid,
      list: list,
    });
    return result;
  }

  async changeStatus(code: string, executor: any) {
    if (this.iReqRid)
      ChangePlanModule.statusChangePlan({
        iReqRid: this.iReqRid,
        code: code,
        executor: `${executor.first_name} ${
          executor.last_name
        } ${executor.middle_name ?? ""}`,
      });
  }

  get loading() {
    return ChangePlanModule.planDetailLoading;
  }

  get btnDisabled() {
    return (
      this.actions ||
      ChangePlanModule.planDetailLoading ||
      this.planDetailList.length == 0
    );
  }

  async created() {
    this.iContractRid = Number(this.$route.params.id);
    this.iReqRid = this.$route.params.idplan
      ? Number(this.$route.params.idplan)
      : null;
    if (
      this.iReqRid &&
      (!ChangePlanModule.currentPlan ||
        ChangePlanModule.currentPlan.record_id != this.iReqRid)
    ) {
      this.gotoHome();
    }
  }

  async startExecuted() {
    if (!this.validateForm()) {
      return;
    }

    const md = new MobileDetect(window.navigator.userAgent);

    //if(window.innerWidth <= 768){
    if (md.mobile()) {
      BaseModule.showMessage({
        message: this.$t("actions.is_mobile").toString(),
        color: "error",
        timeout: 10000,
      });
      return;
    }
    try {
      this.actions = true;
      if (await this.checkExists()) return;
      const id = await this.saveData();
      this.iReqRid = id;
    } finally {
      this.actions = false;
    }
    await this.sign();
  }

  async generateRep(action: ReportAction) {
    await ReportsModule.generateReport({
      action: action,
      path: "application-2-2.prpt",
      type: "pdf",
      filename: this.$t("reportsInfo.application-2.title") as string,
      query: {
        iContractId: this.$route.params.id,
        dDateFrom: this.planDetailList[0].start_date,
        dDateTo: this.planDetailList[0].end_date,
        saveToPower: true,
        planRid: this.iReqRid,
      },
    });
  }
  async mounted() {
    ChangePlanModule.setplanDetailLoading(true);
    await ChangePlanModule.getRequestChangePlan({
      iContractRid: this.iContractRid,
      iReqRid: this.iReqRid,
    });
  }
  get planDetailList() {
    return translate(ChangePlanModule.planDetailList);
  }
  get headers() {
    return [
      {
        text: "№",
        value: "number",
        sortable: false,
      },
      {
        text: this.$t("actions.change-plan.month"),
        value: "month",
        sortable: false,
      },
      {
        text: this.$t("actions.change-plan.kvt"),
        value: "kvt",
        sortable: false,
      },
      {
        text: this.$t("actions.change-plan.kvtnew"),
        value: "kvtnew",
        sortable: false,
      },
    ];
  }

  get user() {
    return AuthModule.user as IUser;
  }

  get ContractNumber() {
    return this.planDetailList.length > 0
      ? this.planDetailList[0].contract_number
      : "";
  }

  get ContractName() {
    return this.planDetailList.length > 0
      ? this.planDetailList[0].contract_name___ru
      : "";
  }

  async sign() {
    const list = this.planDetailList.map(x => ({
      month: x.month,
      value_current: x.value_current,
      value_edit: x.value_edit,
    }));
    const finalXML = {
      title: `Заявление об изменении поставки электроэнергии по договору № ${this.ContractNumber} ${this.ContractName}`,
      params: list,
    };
    const builderxml = new xml2js.Builder();
    const xml = builderxml.buildObject(finalXML);
    const signResult = await this.$refs.ecpSingerRef.sign(xml);
    if (!signResult) return;
    //const parsedJSON = await xml2js.parseStringPromise(signResult);
    // Проверка на отозванность и прочее

    try {
      BaseModule.setLoadingStatus(true);
      const valid = await SignService.validateEDS(
        signResult as string,
        "SIGNATURE",
        this.user.bin,
      );
      const { result: v_result, message: v_message } = valid;
      if (!v_result) {
        return BaseModule.showMessage({
          message: translate(v_message as ApiMessageObject).name as string,
          color: "error",
        });
      } else {
        await ChangePlanModule.saveSign({
          iContractRid: this.iContractRid,
          data: signResult as string,
        });
        await this.saveCCPlan();
        await this.changeStatus("executed", v_result);
        await this.generateRep("open");

        this.gotoHome();
      }
    } finally {
      BaseModule.setLoadingStatus(false);
      //
    }
  }

  public async saveCCPlan() {
    return await ChangePlanModule.saveCCPlan({
      iContractRid: this.iContractRid,
      PlanId: this.iReqRid ?? 0,
    });
  }

  extractSignature(
    parsedJSON: { [key: string]: any },
    documentRootName: string = "actDocument",
  ): string {
    // определяем количество подписей
    const signaturesLength = parsedJSON.actDocument["ds:Signature"].length;
    return parsedJSON[documentRootName]["ds:Signature"][signaturesLength - 1][
      "ds:SignatureValue"
    ][0];
  }
}
